export interface SeguimientoByEstado {
    todos: number,
    aprobados: number,
    rechazados: number,
    publicados: number
}

export function GetVoidSeguimientoByEstado(): SeguimientoByEstado {
    return {
        todos: 0,
        aprobados: 0,
        rechazados: 0,
        publicados: 0
    }
}